<template>
  <v-date-picker
    is24hr
    v-model="range"
    mode="dateTime"
    is-range
    locale="vi-VN"
    :masks="masks"
    @input="updateRange"
    :attributes="attrs"
    :popover="popover"
    :columns="$screens({ default: 1, lg: 2 })"
    :hide-time-header="true"
  >
    <template v-slot="{ inputValue, inputEvents }">
      <div class="flex justify-center items-center">
        <b-form-input
          readonly
          :value="`${inputValue.start || 'DD/MM/YYYY HH:mm'} ➙ ${inputValue.end || 'DD/MM/YYYY HH:mm'}`"
          v-on="inputEvents.start"
          :disabled="disabled"
        />
      </div>
    </template>
  </v-date-picker>
</template>

<script>
  export default {
    props: {
      value: {
        type: Object,
        default() {
          return {
            startDate: null,
            endDate: null,
          }
        },
      },
      keyStartDate: {
        type: String,
        default: 'startDate',
      },
      keyEndDate: {
        type: String,
        default: 'endDate',
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      popover: {
        type: Object,
        default() {
          return {
            visibility: 'click',
            positionFixed: true,
          }
        },
      },
    },
    data() {
      return {
        range: {
          start: null,
          end: null,
        },
        masks: {
          input: 'h:mm A DD-MM-YYYY',
        },
        attrs: [
          {
            key: 'today',
            dot: true,
            dates: new Date(),
          },
        ],
        // popover: {
        //   visibility: 'click',
        //   positionFixed: true
        // }
      }
    },
    methods: {
      updateRange(e) {
        const startDate = e.start
        const endDate = e.end
        const dateRangeData = {
          [this.keyStartDate]: startDate,
          [this.keyEndDate]: endDate,
        }
        this.$emit('input', dateRangeData)
      },
    },
    watch: {
      value: {
        handler() {
          const startDate = this.value[this.keyStartDate] ?? null
          const endDate = this.value[this.keyEndDate] ?? null
          this.range = {
            start: startDate,
            end: endDate,
          }
        },
        deep: true,
        immediate: true,
      },
    },
  }
</script>

<style scoped lang="scss">
  ::v-deep(.vc-container) {
    .vc-pane-container {
      .vc-pane-layout {
        .vc-pane {
          min-width: 180px !important;
          .vc-header {
            .vc-title {
              font-size: 14px !important;
            }
          }
          .vc-weeks {
            padding: 2px !important;
            display: grid;
            grid-template-columns: repeat(7, 0fr);
            position: relative;
            min-width: 180px;
            gap: 0;
            .vc-weekday {
              font-size: 12px !important;
              line-height: 12px;
              padding-top: 2px;
              padding-bottom: 4px;
            }
          }
          .vc-day {
            min-height: 24px !important;
            .vc-day-content {
              font-size: 12px !important;
              width: 24px !important;
              height: 24px !important;
              line-height: 24px !important;
              // &.vc-focusable {

              // }
            }
            .vc-highlights {
              .vc-day-layer {
                .vc-highlight {
                  width: 24px !important;
                  height: 24px !important;

                  &.vc-highlight-base-start {
                    border-top-left-radius: 50% !important;
                    border-bottom-left-radius: 50% !important;
                  }
                  &.vc-highlight-base-end {
                    border-top-right-radius: 50% !important;
                    border-bottom-right-radius: 50% !important;
                  }
                }
              }
            }
          }
        }
      }

      // .vc-arrows-container {
      //   .vc-arrow {
      //     svg {
      //       width: 24px !important;
      //       height: 24px !important;
      //     }
      //   }
      // }

      .vc-time-picker {
        display: inline-flex;
        width: 50%;

        // &:first-child::after {
        //   content: '->';
        //   margin-left: 50px;
        // }

        .vc-date-time {
          .vc-date {
            display: none;
          }
          .vc-time {
            .vc-select {
              select {
                height: 24px !important;
                font-size: 14px !important;
              }
            }
          }
        }
      }
    }
  }
</style>
